export default __webpack_public_path__ + "images/assets/e01bcabbc82bbcedb2800452533b8fb0.svg";